import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface RemoveVDRFileRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const RemoveVDRFile = createAsyncThunk(
    'dataRoom/removeFile',
    async (
        { engagementId, fileId, fileSourceType }: RemoveVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.delete(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not remove file at the moment.',
                    'error'
                );
                throw new Error('Failed to remove file');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while removing file.',
                'error'
            );
            throw error;
        }
    }
);

